<template>
  <!-- list | board, as one segmented control. shared by the support ticket
       list and the Ticket Board so the two views switch with the same
       gesture in the same place. -->
  <span class="svt" role="group" aria-label="Ticket view">
    <router-link :to="{ name: 'help_center', query: { tab: 'support' } }"
                 class="svt-btn" :class="{ 'svt-btn--active': active === 'list' }"
                 :aria-current="active === 'list' ? 'page' : null"
                 title="List view" aria-label="List view">
      <i class="fa fa-list" aria-hidden="true"></i>
    </router-link>
    <router-link :to="{ name: 'support_ticket_board' }"
                 class="svt-btn" :class="{ 'svt-btn--active': active === 'board' }"
                 :aria-current="active === 'board' ? 'page' : null"
                 title="Board view" aria-label="Board view">
      <i class="fa fa-columns" aria-hidden="true"></i>
    </router-link>
  </span>
</template>

<script>
export default {
  name: 'SupportViewToggle',
  props: {
    active: { type: String, required: true, validator: v => ['list', 'board'].includes(v) },
  },
}
</script>

<style scoped>
.svt {
  display: inline-flex; align-items: stretch;
  border: 1px solid var(--fi-line-strong, #d6dde6);
  border-radius: var(--fi-radius-pill, 999px);
  overflow: hidden;
  background: var(--fi-surface, #fff);
  vertical-align: middle;
}
/* !important on the colours: App.vue paints every non-.btn anchor with the
   link colour at !important, and these are anchors */
.svt-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 29px;
  font-size: 13px;
  color: var(--fi-text-muted, #6b7280) !important;
  text-decoration: none !important;
  transition: background .12s, color .12s;
}
.svt-btn + .svt-btn { border-left: 1px solid var(--fi-line, #e2e7ec); }
.svt-btn:hover { background: var(--fi-surface-sunken, #eef4fb); color: var(--fi-text, #374151) !important; }
.svt-btn--active,
.svt-btn--active:hover {
  background: var(--fi-ops-accent, #3a6e99);
  color: #fff !important;
  cursor: default;
}
.svt-btn:focus-visible { outline: 2px solid var(--fi-ops-accent, #3a6e99); outline-offset: -2px; }
</style>
